import type { BusinessAnalyticsConfig } from "@xepp/business-analytics-sdk";
import { resolveUtilityName } from "../../tenant/branding/resolveTenant";

/**
 * Connection details for the business analytics SDK.
 *
 * The SDK reads no environment variables of its own — it is deliberately portable, so
 * every host-specific convention stops here. This module is the only place that knows
 * about `REACT_APP_*`.
 */

/** The same gateway every other backend call uses; analytics lives under /api/businessanalytics on it. */
export const BUSINESS_ANALYTICS_ENDPOINT = process.env.REACT_APP_SERVER_URL ?? "";

/** Public by design: it ships in the bundle, like the Flagsmith environment key. */
export const BUSINESS_ANALYTICS_API_KEY = process.env.REACT_APP_BUSINESS_ANALYTICS_SDK_API_KEY ?? "";

/**
 * The same host-derived utility code every other backend call already sends — not a
 * build-time value. The multitenancy deployment serves all tenants from one image, so a
 * baked-in acronym would be wrong there, and the backend rejects an empty one outright.
 */
export const BUSINESS_ANALYTICS_UTILITY_NAME = resolveUtilityName();

export const businessAnalyticsConfig: BusinessAnalyticsConfig = {
	apiKey: BUSINESS_ANALYTICS_API_KEY,
	endpoint: BUSINESS_ANALYTICS_ENDPOINT,
	utilityName: BUSINESS_ANALYTICS_UTILITY_NAME,
	debug: process.env.NODE_ENV === "development",
};
